const binding = { modules: {}, dataActions: {} };

    (binding.modules['commerce-web-module'] = {
        c: () => require('partner/modules/commerce-web-module/commerce-web-module.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'commerce-web-module',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/commerce-web-module'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|commerce-web-module|commerce-web-module'] = {
                c: () => require('partner/modules/commerce-web-module/commerce-web-module.view.tsx'),
                cn: '__local__-__local__-commerce-web-module'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };